module.exports = __webpack_public_path__ + "img/selected_camera_ok.577a442f.svg";